/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../core/utils"
import { REQUIRED_MESSAGE } from "./defaultMessages"
import "./styles.css"
import DOMPurify from "dompurify"
import React from "react"
import { Col, Form, Row } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"

function renderOptinLabel(label) {
  if (typeof label !== "string") return label
  // If label contains HTML (e.g. <a ...>, <br>), render it safely.
  if (label.includes("<a") || label.includes("<br")) {
    const html = DOMPurify.sanitize(label, {
      USE_PROFILES: { html: true },
      ALLOWED_TAGS: ["a", "b", "strong", "i", "em", "u", "br", "span"],
      ALLOWED_ATTR: ["href", "target", "rel", "alt"],
      // ADD_ATTR requis : avec USE_PROFILES seul, DOMPurify retire target malgré ALLOWED_ATTR
      ADD_ATTR: ["target", "rel", "alt"]
    })
    return <span dangerouslySetInnerHTML={{ __html: html }} />
  }
  return label
}

export const CheckBoxOptin = (props) => {
  const { label, metaError, meta, input } = props

  return (
    <>
      <Col lg={{ span: 12 }} md={{ span: 12 }} xs={{ span: 12 }} className=" pr-0 pl-0">
        <div className="d-flex align-items-center">
          <input
            {...input}
            type="checkbox"
            aria-label={`${input.name?.toLowerCase()}`}
            id={input.name}
            checked={input.value}
          />

          <Form.Label className="mr-2" htmlFor={input.name}>
            {typeof label === "function" ? renderOptinLabel(label()) : renderOptinLabel(label)}
          </Form.Label>
        </div>
      </Col>
      {metaError && (
        <Col lg={{ span: 12 }} md={{ span: 12 }} xs={{ span: 12 }} className="pr-0 pl-0 mt-2">
          <p className="required-message">{meta.error || meta.submitError}</p>
        </Col>
      )}
    </>
  )
}

export const RadioOptin = (props) => {
  const { label, metaError, meta, input } = props

  const ElementHtml = label

  return (
    <>
      <Row className="d-flex  align-items-center justify-content-center   mr-0 ml-0 w-100">
        <Col lg={{ span: 8, order: 1 }} md={{ span: 8, order: 1 }} xs={{ span: 12, order: 1 }} className="pr-0 pl-0">
          <Form.Label className="mr-2">
            {typeof label === "string" ? renderOptinLabel(label) : <ElementHtml />}
          </Form.Label>
        </Col>
        <Col
          lg={{ span: 4, order: 2 }}
          md={{ span: 4, order: 2 }}
          xs={{ span: 12, order: 2 }}
          className="align-item-end  pr-0 pl-0"
        >
          <Row className="d-flex  align-items-center justify-content-center   mr-0 ml-0 md-margintop">
            <Col className="d-flex justify-content-around align-items-center  pr-0 pl-0">
              <div className="mr-3">
                <input {...input} type="radio" value={true} className="form-label" aria-label={`${label}-yes`} />
                <Form.Label className="form-label">{loc("yes")}</Form.Label>
              </div>
              <div>
                <input {...input} type="radio" value={false} className="form-label" aria-label={`${label}-no`} />
                <Form.Label className="form-label">{loc("no")}</Form.Label>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {metaError && (
        <Row className="d-flex  align-items-center justify-content-center   mr-0 ml-0 md-margintop">
          <Col lg={{ span: 12 }} md={{ span: 12 }} xs={{ span: 12 }} className="pr-0 pl-0 mt-2">
            <p className="required-message">{meta.error || meta.submitError}</p>
          </Col>
        </Row>
      )}
    </>
  )
}

export default function Optin(props) {
  const { optin, hidden, tunnelData } = props

  const { code, label, type, required } = optin

  const validate = (value) => {
    if (required && (value === undefined || value === "" || value === false)) {
      return loc(REQUIRED_MESSAGE)
    }
  }

  return hidden ? null : (
    <FinalFormField name={code} component="input" className="form-control" validate={validate} type={type} id={code}>
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched

        return (
          <Row className={`optin ${code.toLowerCase()} mr-0 ml-0 mt-8 mb-8 justify-content-between`}>
            {type.toLowerCase() === "checkbox" ? (
              <CheckBoxOptin input={input} label={label} metaError={metaError} meta={meta} />
            ) : (
              <RadioOptin input={input} label={label} metaError={metaError} meta={meta} />
            )}
          </Row>
        )
      }}
    </FinalFormField>
  )
}
